module.exports = __webpack_public_path__ + "img/6922840.png";